import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from '../reducers';
import createSagaMiddleware from 'redux-saga';
import ErrorReporterMiddleware from './ErrorReporterMiddleware';
import BreadcrumbLoggerMiddleware from './BreadcrumbLoggerMiddleware';
import RoxanneEventMiddleware from './AnalyticsEventMiddleware';
import rootSaga from '../sagas';
import { InlineConfig } from '../typedefs/external';
import { DICWindow } from '../typedefs/window';

declare var window: DICWindow;

const configureStore = (inlineConfig: InlineConfig) => {
    const initialState = {
        settings: { botId: 4, bootstrapped: false, boolean: false, inlineConfig },
    };
    const sagaMiddleware = createSagaMiddleware({
        onError: e => {
            if (window.DIConv.Bugsnag) {
                window.DIConv.Bugsnag.notifyException(e, 'Saga Error');
            }
        },
    });
    const middleware = [
        ErrorReporterMiddleware(),
        sagaMiddleware,
        RoxanneEventMiddleware(),
        BreadcrumbLoggerMiddleware(),
    ];

    const store = createStore(
        rootReducer,
        initialState,
        composeWithDevTools(applyMiddleware(...middleware)),
    );

    if (module.hot) {
        module.hot.accept('../reducers', () => {
            const nextRootReducer = require('../reducers/index');
            store.replaceReducer(nextRootReducer);
        });
    }

    sagaMiddleware.run(rootSaga);

    return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/store/index.ts